import React from "react";

import { HomeIcon } from "@/assets/icons";
import { ActivitiesPage, AddBroker, CookiePolicyPage, PrivacyPolicyPage, TermsOfUsePage } from "@/components/features";
import Dashboard from "@/components/pages/Dashboard/Dashboard";
import ErrorPage from "@/components/pages/ErrorPage/ErrorPage";
import { fakeI18n } from "@/i18n";
import { AppRoute, RouteItem } from "@/shared/domain";
import { isABroker } from "@/shared/hooks";
import { Scope } from "@/shared/hooks/useAuth/types";

export const otherRoutes = (): RouteItem[] => {
    return [
        {
            path: AppRoute.Root,
            element: <Dashboard />,
            breadcrumb: HomeIcon,
        },
        {
            path: AppRoute.RelatedActivities,
            element: <ActivitiesPage />,
            breadcrumb: fakeI18n.t("Breadcrumbs.Activities"),
        },
        {
            path: AppRoute.CookiePolicy,
            allScopesAllowed: true,
            element: <CookiePolicyPage />,
        },
        {
            path: AppRoute.PrivacyPolicy,
            allScopesAllowed: true,
            element: <PrivacyPolicyPage />,
        },
        {
            path: AppRoute.TermsOfUse,
            allScopesAllowed: true,
            element: <TermsOfUsePage />,
        },
        {
            path: AppRoute.Error,
            allScopesAllowed: true,
            element: <ErrorPage />,
        },
        ...(!isABroker()
            ? [
                  {
                      path: AppRoute.AddBroker,
                      element: <AddBroker />,
                      denyScopes: [Scope.Preview],
                  },
              ]
            : []),
    ];
};
